import {LinearProgress, Tooltip} from '@mui/material'


import {Link} from 'react-router-dom'
import React, {useEffect, useState} from "react";
import {getSplash} from "../services/services";
import Animatedtype from "../components/extras/Animated";



const Footer = () => {
    const [data, setData] = useState(false)

    const getData = async () => {
        const response = await getSplash()
        if (response && response.data.code == 1) {
            setData(response.data)
        } else {
           alert('مشکل در ارتباط با سرور')
        }
    }


    useEffect(() => {

        getData()
    }, []);


    let content
    if (data !== false) {

        content = <p className="mt-3 has-text-justified has-text-weight-bold">
            {data.options.about}
        </p>
    } else {
        content = <div className='column is-12'>
            <LinearProgress variant='indeterminate' color='secondary' sx={{
                '&.MuiLinearProgress-root': {
                    backgroundColor: '#219ebc'
                }

            }}/>
        </div>
    }


    return (<>
        <footer className='containerwidth clrone has-text-white  borderrad1 pb-3 '>
            <div className="columns is-multiline    mx-0 px-2  mt-6 ">

                <div className="column is-12">
                    <h4 className='pinar is-size-4 has-text-white has-text-weight-bold my-3 has-text-centered'>
                        از این به بعد کارهای  <Animatedtype/>  رو به بازرگانی قاسمی بسپر !
                    </h4>

                </div>
                <div className="column  is-5-desktop">
                    <div className="column   is-12-desktop ">
                            <span className="is-flex is-align-items-center ">
                             <img
                                 src="/images/white%20logo.png"
                                 alt="logo"
                                 width="200"
                                 height="200"
                             />
                                           <h4 className="mr-2 ">بازرگانی قاسمی</h4>
                          </span>

                        {
                            content
                        }


                        <a
                            target="_blank"
                            href="https://trustseal.enamad.ir/?id=485246&Code=fgZvdEKfQ0hTBsVj1FV5uGuajKPJ03lX"
                        >
                            <img
                                referrerPolicy="origin"
                                src="https://trustseal.enamad.ir/Content/Images/Star2/81.png?v=5.0.0.3777"
                                alt=""
                                style={{cursor: "pointer", borderRadius: '0.3rem'}}
                                code="fgZvdEKfQ0hTBsVj1FV5uGuajKPJ03lX"
                            />
                        </a>

                    </div>

                </div>
                <div className="column  mt-5 px-5">
                   <h4 className='has-text-white'>ارتباط با ما</h4>

                    <ul className="mt-4 footer__contact">
                        <li className="footer__phone">شماره تماس</li>
                        <li>

                            {
                                data !== false ? <a style={{color: 'inherit'}}
                                                    href={`tel:${data.options.phone}`}>{data.options.phone}</a> : "..."
                            }
                        </li>

                    </ul>
                    <ul className="mt-4 footer__contact">
                        <li className="footer__gmail">ایمیل</li>
                        <li>

                            {
                                data!== false ? <a style={{color: 'inherit'}}
                                                    href={`mailto:${data.options.email}`}>{data.options.email}</a> : "..."
                            }
                        </li>
                    </ul>
                    <ul className="mt-4 footer__contact">
                        <li className="footer__loc">آدرس</li>
                        <li>

                            {
                                data!== false ? <a target={"_blank"} style={{color: 'inherit'}}
                                                    href={`https://www.google.com/maps/@${data.options.lat},${data.options.lng},15z?entry=ttu}`}>{data.options.address} </a> : "..."
                            }
                        </li>
                    </ul>
                </div>
                <div className="column  mt-5 px-5 ">
                    <h4 className='has-text-white'>لینک های سریع</h4>
                    <ul className="mt-4">
                        <Link className='has-text-white' to={'/news/'}>
                            <li>محصولات</li>
                        </Link>





                    </ul>
                </div>



            </div>
            <div className='column is-12-mobile'>
                <div className="is-flex socials_foot is-align-items-center is-justify-content-space-around ">
              <span
                  className="is-flex is-align-items-center is-justify-content-center mx-1"
              >
                  <a href={data && data.options.whatsapp} target='_blank' rel='noopener noreferrer'>
                      <img src="/icons/whatsapp.png" alt=""/>
                  </a>


              </span>
                    <span
                        className="is-flex is-align-items-center is-justify-content-center mx-1"
                    >
                        <a href={data && data.options.telegram} target='_blank' rel='noopener noreferrer'>
                      <img src="/icons/telegram.png" alt=""/>
                  </a>

              </span>

                    <span
                        className="is-flex is-align-items-center is-justify-content-center mx-1"
                    >
                              <a href={data && data.options.email} target='_blank' rel='noopener noreferrer'>
                        <img src="/icons/gmail.png" alt=""/>
                  </a>

              </span>
                    <span
                        className="is-flex is-align-items-center is-justify-content-center mx-1"
                    >
                        <a href={data && data.options.instagram} target='_blank' rel='noopener noreferrer'>

                      <img src="/icons/instagram.png" alt=""/>
                  </a>

              </span>
                </div>
                <p className='has-text-white has-text-centered'>
                    کپی رایت 2026 – تمام حقوق برای بازرگانی قاسمی
                    محفوظ است.


                </p>
            </div>

        </footer>

    </>)
}

export default Footer;